import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'projects/shared/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LinksService {
  // ❌ OLD (buggy): URLApp = environment.apiUrl.replace(/api-/, "").replace(/api./, "").replace('v1', '').slice(0, -1) +'en/';
  // ✅ NEW: Remove hardcoded 'en/' — it will be added dynamically when needed
  private _baseUrl: string;
  
  constructor() {
    // Extract base URL without locale
    const raw = environment.apiUrl
      .replace(/api-/, "")
      .replace(/api\./, "")
      .replace('v1', '')
      .replace(/\/+$/, ''); // Remove trailing slashes
    
    // Remove any existing locale suffix (/en or /ar)
    this._baseUrl = raw.replace(/\/(en|ar)$/i, '');
  }

  /**
   * Base URL without locale (e.g., 'https://card4games.com')
   * Use UrlUtility.buildUrl() to construct full URLs with locale + path
   */
  get baseUrl(): string {
    return this._baseUrl;
  }

  private router = inject(Router, { optional: true });

  /**
   * @deprecated Use baseUrl + UrlUtility.buildUrl() instead
   * Kept for backward compatibility — returns base + the language of the page being shown ('en/' or 'ar/').
   * It was hard-wired to 'en/', so Arabic pages announced English URLs in og:url and structured data.
   */
  get URLApp(): string {
    const match = /^\/(en|ar)(\/|$|\?|#)/i.exec(this.router?.url ?? '');
    return `${this._baseUrl}/${match ? match[1].toLowerCase() : 'en'}/`;
  }

  facebook = 'https://www.facebook.com/Card4GamesLTD';
  instgram = 'https://www.instagram.com/card4games/';
}

